import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export const Container = styled.div<{ $size: string }>`
  position: relative;
  width: ${(p) => p.$size};
  height: ${(p) => p.$size};
`;

export const Image = styled.img<{ $visibility: string }>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  visibility: ${(p) => p.$visibility};
`;

export const PlaceholderSVG = styled.svg<{
  $visibility: string;
  $pulse: boolean;
}>`
  visibility: ${(p) => p.$visibility};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  color: ${(p) => p.theme.text.default};
  animation: ${(p) => (p.$pulse ? pulse : "none")} 2s ease-in-out infinite;
`;
